import {BinIcon} from "../../../../../components/icon/Icon";
import {useParams} from "react-router";
import ToAppButton from "../../../../../components/ToAppButton/ToAppButton";
import {useCallback} from "react";
import appHistory from "../../../../../app/appHistory";
import {RouterPaths} from "../../../../../app/appConstants";
import {useGTMEvent} from "../../../../GoogleTagManager/googleTagManagerHooks";
import {OnboardingTutorialCloseButtonStyled} from "./styled/OnboardingTutorialCloseButtonStyled";
import {useOnboardingTutorialContext} from "../../onboardingTutorialContext";

const CloseIcon = () => <BinIcon name="IcXMark" style={{fill: '#7D86B2', fontSize: '24px'}}/>

export const OnboardingTutorialCloseButton = () => {
    const {pushGtmEvent} = useGTMEvent({module: 'OnboardingTutorial'})
    const {attempt} = useParams();
    const {currentStepName} = useOnboardingTutorialContext();

    const handlePushCloseButtonGTMEvent = useCallback(() => {
        pushGtmEvent({button: 'OnboardingTutorialCloseButton', event: 'onboarding_click', attempt, currentStepName})
    }, [attempt, currentStepName, pushGtmEvent])

    const handleInitialButtonClick = useCallback(() => {
        handlePushCloseButtonGTMEvent();
        appHistory.push(RouterPaths.mobileDepositBonus);
    }, [handlePushCloseButtonGTMEvent]);

    const handleRepeatedButtonClick = useCallback(() => {
        handlePushCloseButtonGTMEvent();
    }, [handlePushCloseButtonGTMEvent])

    return attempt === 'initial' ? (
            <OnboardingTutorialCloseButtonStyled onClick={handleInitialButtonClick}>
                <CloseIcon/>
            </OnboardingTutorialCloseButtonStyled>
    ) : (
            <ToAppButton>
                <OnboardingTutorialCloseButtonStyled onClick={handleRepeatedButtonClick}>
                    <CloseIcon/>
                </OnboardingTutorialCloseButtonStyled>
            </ToAppButton>
    )
}